<dm-button-group selectionmode="none" [size]="size()">
  @for (language of languages(); track language.sprache; let index = $index) {
    <dm-button-group-item [active]="activeIndex() === index" (click)="activeIndex.set(index)">
      <dm-flag slot="leading-icon" shape="circle" size="sm" [country]="language.sprache" />
      {{ language.sprache | uppercase }}
      <!-- Hidden rather than left out: a control-flow anchor inside a slotted item reads as text there. -->
      <dm-icon-dot
        slot="trailing-icon"
        size="sm"
        [color]="dotColorByState[language.state]"
        [style.display]="showsState() ? null : 'none'"
      />
    </dm-button-group-item>
  }
</dm-button-group>
